<template>
    <div>
        <div>
            <div id="hello-hello">
                <p style="display:inline;float: left;line-height: 22px;"><b>-首检项目列表</b></p>

                <p style="display:inline;float: right;line-height: 40px;margin: 5px 0;">
                    <el-button round type="primary" @click="openInspectionDialog">新增项目</el-button>
                </p>
            </div>

            <el-table :data="baseInspectionList" style="width: 100%" tooltip-effect="dark">
                <el-table-column type="index" width="20" fixed>
                </el-table-column>

                <el-table-column prop="inspectionName" label="首检名称" min-width="40%" fixed>
                </el-table-column>

                <!-- <el-table-column prop="statusDes" label="状态" width="70">
                    <template slot="header">
                        <el-tooltip class="item" effect="light" placement="top" content="状态：禁用、启用">
                            <span>状态</span>
                        </el-tooltip>
                    </template>
                </el-table-column> -->
                <el-table-column prop="maker" label="创建人" min-width="13%">
                </el-table-column>
                <el-table-column prop="createdTime" label="创建时间" width="110">
                </el-table-column>

                <el-table-column fixed="right" label="操作" width="80">
                    <template slot-scope="scope">
                        <!-- <el-button @click="processHandleClick(scope.row)" type="success" round size="small">
                            编辑
                        </el-button> -->
                        <el-button @click="deleteClick(scope.row)" type="danger" round size="small">
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>

            <el-dialog title="首检项目详情" :visible.sync="inspectionDlgVisible" width="60%">

                <el-form :inline="true" :model="inspectionForm">
                    <el-form-item label="项目名称" required :label-width="formLabelWidth">
                        <el-input v-model="inspectionForm.inspectionName" autocomplete="off" style="width:400px"
                            :disabled="processNameDisable"></el-input>
                    </el-form-item>
                </el-form>

                <div slot="footer" class="dialog-footer">
                    <el-button @click="inspectionDlgVisible = false">取 消</el-button>
                    <el-button type="primary" @click="addBaseInspection">保 存</el-button>
                </div>
            </el-dialog>

        </div>
    </div>
</template>

<script>
import Sortable from 'sortablejs'

export default {
    name: "FirstInspectionBase",
    data() {
        return {
            token: this.getToken(),
            userId: this.getUserId(),
            companyId: this.getCompanyId(),

            formLabelWidth: '120px',
            rules: {
                productName: [
                    { required: true, message: '请输入产品名称', trigger: 'blur' },
                    { required: true, message: '请输入产品名称', trigger: 'change' }
                ],

            },
            inspectionDlgVisible: false,
            inspectionForm: {
                id: '',
                inspectionName: '',
            },
            baseInspectionList: []
        }
    },
    methods: {
        deleteClick(row) {
            this.$confirm('确定要删除吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {

                this.removeBaseInspection(row)

            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                })
            })
        },
        //行拖拽
        rowDrop() {
            const tbodys = document.querySelectorAll('.el-table__body tbody')//[8]
            // console.log(tbodys)

            const tbody = document.body.querySelector('.el-table__body tbody')
            // console.log('tbody')
            // console.log(tbody)

            const _this = this
            // console.log('_this')
            // console.log(_this)

            Sortable.create(tbody, {
                onEnd({ newIndex, oldIndex }) {
                    if (newIndex == oldIndex) return

                    _this.productList.splice(newIndex, 0, _this.productList.splice(oldIndex, 1)[0])

                    var newArray = _this.productList.slice(0)
                    // console.log('newArray')
                    // console.log(newArray)

                    _this.productList = []

                    _this.$nextTick(function () {
                        _this.productList = newArray

                        this.sort(newArray)
                    })

                }
            })

        },
        sort(val) {
            // console.log('sort()')
            const baseBOMInfoVOList = []
            

            this.$axios({
                method: "post",
                url: "/shiro/base/bom/sort",
                data: {
                    baseBOMInfoVOList: val,
                    companyId: this.companyId
                },
                headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status === 400) {
                    this.$router.push({ path: "/Login" })
                }

            })
        },
        openInspectionDialog() {

            this.inspectionForm.id = ''
            this.inspectionForm.inspectionName = ''

            this.inspectionDlgVisible = true
        },
        addBaseInspection() {

            const form = new FormData()

            form.append('id', this.inspectionForm.id)

            form.append('inspectionName', this.inspectionForm.inspectionName)
            form.append('maker', this.userId)
            form.append('companyId', this.companyId)

            this.$axios({
                method: "post",
                url: "/shiro/base/inspection/add",
                data: form,
                headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status != 200) {
                    this.$message({
                        type: 'info',
                        message: data.msg
                    })
                    return
                }

                this.inspectionDlgVisible = false

                this.getAllBaseInspection()
            })
        },
        getAllBaseInspection() {
            this.$axios({
                method: "post",
                url: "/shiro/base/inspection/getAll",
                data: {
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status === 400) {
                    this.$router.push({ path: "/Login" })
                }

                if (data.status != 200) {
                    this.$message({
                        type: 'info',
                        message: data.msg
                    })
                    return
                }

                this.baseInspectionList = data.data
                for (let i in this.baseInspectionList) {
                    this.baseInspectionList[i].createdTime = this.$moment(this.baseInspectionList[i].createdTime).format("YYYY-MM-DD")
                }
            })
        },
        removeBaseInspection(row) {
            this.$axios({
                method: "delete",
                url: "/shiro/base/inspection/remove",
                data: {
                    id: row.id,
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {

                this.getAllBaseInspection()
            })
        }
    },
    mounted() {
        this.setDefaultPath('/firstInspectionBase')

        // 阻止默认行为
        document.body.ondrop = function (event) {
            event.preventDefault();
            event.stopPropagation();
        };
        this.rowDrop()//行拖拽

        this.getAllBaseInspection()
    }
}
</script>

<style>
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409EFF;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}

#create_work {
    position: relative;
    right: 5px;
    width: 120px;
}

.DisabledSelection .el-checkbox__inner {
    display: none;
    position: relative;
}
</style>